import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

/**
 * Fetches the flat log file list and renders a <select> dropdown.
 * @param {{ onSelect: (filePath: string) => void, selectedFile: string|null }} props
 */
export default function FileSelector({ onSelect, selectedFile }) {
  const { token, logout } = useAuth();
  const [files, setFiles]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  useEffect(() => {
    async function fetchFiles() {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${BACKEND_URL}/api/logs/files`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.status === 401) { logout(); return; }
        if (!res.ok) throw new Error("Failed to fetch log files.");

        const data = await res.json();
        setFiles(data.flat || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchFiles();
    // Refresh file list every 60 s (handles new log files appearing)
    const interval = setInterval(fetchFiles, 60_000);
    return () => clearInterval(interval);
  }, [token, logout]);

  if (loading) return <div className="selector-bar"><span style={{ color: "#8b949e", fontSize: "0.85rem" }}>Loading files…</span></div>;
  if (error)   return <div className="selector-bar"><span style={{ color: "#f85149", fontSize: "0.85rem" }}>⚠️ {error}</span></div>;

  return (
    <div className="selector-bar">
      <label htmlFor="file-select">Log File:</label>
      <select
        id="file-select"
        value={selectedFile || ""}
        onChange={(e) => e.target.value && onSelect(e.target.value)}
      >
        <option value="">— Select a log file —</option>
        {files.map((f) => (
          <option key={f.path} value={f.path}>
            {f.label}
          </option>
        ))}
      </select>
      <span style={{ fontSize: "0.75rem", color: "#8b949e", whiteSpace: "nowrap" }}>
        {files.length} file{files.length !== 1 ? "s" : ""}
      </span>
    </div>
  );
}
